import React, { useContext, useState } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { IconActionDropDown } from 'wg-fe-ui';

interface Props {
  title: string;
  defaultOpen?: boolean;
  show?: boolean;
}

const CollapseContainer: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  defaultOpen = false,
  show = true,
  children,
  ...otherProps
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);
  const theme = useContext(ThemeContext);

  // Useful for if collapse container is mobile only
  if (!show) {
    return <div {...otherProps}>{children}</div>;
  }

  return (
    <div {...otherProps}>
      <TitleContainer onClick={() => setIsOpen((prev) => !prev)}>
        {title}
        {/* replace by round cornered chevron */}
        <IconContainer inverted={isOpen}>
          <IconActionDropDown color={theme.gray[300]} />
        </IconContainer>
      </TitleContainer>
      <Content visible={isOpen}>{children}</Content>
    </div>
  );
};

const Content = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => !visible && 'none'};
  padding-bottom: 1.6rem;
`;

const IconContainer = styled.div<{ inverted?: boolean }>`
  transition: 0.2s;
  transform: ${({ inverted }) => inverted && 'rotate(180deg)'};
  > svg {
    width: 2.4rem;
    height: 2.4rem;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 5.6rem;
  padding: 0.8rem 0;
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 120%;
`;

export default CollapseContainer;
